import Vue from "vue";
import VueCookies from "vue-cookies";
import VueI18n from "vue-i18n";
import EnLocale from "./en";
import FrLocale from "./fr";
import EsLocale from "./es";
import PtLocale from "./pt";
import RuLocale from "./ru-RU";
import ZhLocale from "./zh-CN";
import elementEnLocale from "element-ui/lib/locale/lang/en";
import elementFrLocale from "element-ui/lib/locale/lang/fr";
import elementEsLocale from "element-ui/lib/locale/lang/es";
import elementPtLocale from "element-ui/lib/locale/lang/pt";
import elementRuLocale from "element-ui/lib/locale/lang/ru-RU";
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";

Vue.use(VueCookies);
Vue.use(VueI18n);

const messages = {
  en: {
    ...EnLocale,
    ...elementEnLocale
  },
  fr: {
    ...FrLocale,
    ...elementFrLocale
  },
  es: {
    ...EsLocale,
    ...elementEsLocale
  },
  pt: {
    ...PtLocale,
    ...elementPtLocale
  },
  ru: {
    ...RuLocale,
    ...elementRuLocale
  },
  zh: {
    ...ZhLocale,
    ...elementZhLocale
  }
};

export function getLanguage() {
  const chooseLang = Vue.prototype.$cookies.get("accept-lang");
  if (chooseLang) {
    return chooseLang;
  }
  const language = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.includes(locale)) {
      return locale;
    }
  }
  return "en";
}

export function setLanguage(lang) {
  Vue.prototype.$cookies.set("accept-lang", lang, "1y");
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js